import * as React from "react";
const LinkArrow = props => <symbol viewBox="0 0 24 24" {...props}>
    <path d="M21.53 11.477l-5-5a.757.757 0 00-.53-.221c-.198 0-.393.08-.532.22s-.22.334-.22.53c0 .198.082.393.222.532l3.702 3.702H3a.75.75 0 100 1.5h16.207l-3.737 3.737a.757.757 0 00-.222.531c0 .197.08.392.22.532s.334.22.531.22a.756.756 0 00.531-.222l5-5c.14-.14.22-.333.22-.53s-.08-.391-.22-.53z" />
  </symbol>;
export default LinkArrow;